import { render } from "./App.vue?vue&type=template&id=4c66df35"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4c66df35&lang=scss"

import exportComponent from "/Users/tingwei/Desktop/大崗山青年商會/jcidks2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__